import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NotificationService } from '../../../core/services/notification.service';
import { AppService } from '../../../app.service';
import { ComponentPageBase } from '../../../shared/components/component-page-base/component-page-base';
import { ContragentsService } from '../contragents.service';
import { Contragent } from '../../../shared/models/contragent/Contragent';
import {CategoryType} from "../../../shared/enums/category-type.enum";
import {LookupService} from "../../../shared/services/lookup.service";
import {KeyValueObject} from "../../../shared/models/core/KeyValueObject";
import {EntityViewModel} from "../../../shared/models/core/EntityViewModel";
import { ServiceCentersService } from '../../../shared/services/service-centers.service';
import { UpdateServiceCenterCustomCommand } from '../../../shared/models/request/update-service-center-custom/update-service-center-custom-command';
import { ContragentWithContactDto } from '../../../shared/models/contragent/contragent-with-contact-dto';
import { DaDataAddressComponent } from '../../../shared/components/dadata-address/dadata-address.component';
import { AddressSuggestion } from '../../../shared/models/dadata-address/address-suggestion';
import { DropdownListCountryPhoneMasksComponent } from '../../../shared/components/dropdownlist-country-phone-masks/dropdownlist-country-phone-masks.component';
import { hasUtmTags } from '../../../shared/utils/utm-tag-parser';
import { AgreementsService } from '../../../shared/services/agreements.service';
import { AgreementState } from '../../../shared/enums/agreement-state.enum';
import { AgreementListItem } from '../../../shared/models/agreement/agreement-list-item';

const flatten = filter => {
  const filters = filter.filters;
  if (filters) {
    return filters.reduce((acc, curr) => acc.concat(curr.filters ? flatten(curr) : [curr]), []);
  }
  return [];
};

@Component({
  selector: 'categories-contragent',
  templateUrl: './contragent.page.html',
	styleUrls: [
    './contragent.page.scss',
    '../../../../vendor/libs/angular2-ladda/angular2-ladda.scss'
  ]
})
export class ContragentPage extends ComponentPageBase<Contragent> implements OnInit {

	@ViewChild("dadataAddressControl") dadataAddressControl: DaDataAddressComponent;
	@ViewChild('countryPhoneMasksComponent') countryPhoneMasksComponent: DropdownListCountryPhoneMasksComponent;

  	headerName = "Основное";
	activeIdString: any = "main-tab";
	changeLogCategoryEntityIds: { [categoryId: number]: number[] } = {};
	readonly hasUtmTags = hasUtmTags;

	cellPhoneMask: string = "+7 (000) 000-00-00";
	public rules: { [key: string]: RegExp } = {
		'0': /\d/
	};

	paymentTypes: KeyValueObject[] = [];
	contragentTypes: KeyValueObject[] = [];
	contragentProjects: KeyValueObject[] = [];
	clientAgreements: KeyValueObject[] = [];
	agreementId: number = null;
	projectsLoading: boolean = false;
	projectsContextReady: boolean = false;
	projectDefaultItem = new KeyValueObject(null, "(Не указан)");
	loaded: boolean = false;

	contragent: ContragentWithContactDto = null;
	updatedContragent: ContragentWithContactDto;

	constructor(
		private lookupService: LookupService,
		protected route: ActivatedRoute,
		protected router: Router,
		protected appService: AppService,
		protected notificationService: NotificationService,
		protected dataService: ContragentsService,
		protected serviceCentersService: ServiceCentersService,
		private agreementsService: AgreementsService,
	) {
		super(route, router, appService, notificationService, dataService);
		this.listPageRoutePath = 'categories/contragents';
	}

	ngOnInit(): void {
		this.entityId = this.route.snapshot.paramMap.get('contragentId');
		
		this.lookupService.getData('payment-types', null).subscribe(resp => {
			this.paymentTypes = resp;
		});
		this.lookupService.getData("contragentTypes", null).subscribe(resp =>{
			this.contragentTypes = resp;
		});
        
		if (this.entityId != null) {
            this.dataService.getContragentWithContact(+this.entityId).subscribe(vm => {
				this.entityName = `${vm.name}`;
				this.contragent = vm;
				this.changeLogCategoryEntityIds = {};
				this.changeLogCategoryEntityIds[<number>CategoryType.contragents] = [vm.id];
				this.changeLogCategoryEntityIds[<number>CategoryType.customerObjects] = vm.customerObjects.map(x => x.customerObjectId);
				this.loaded = true;
				this.canEditForm = false;
				this.loadClientProjectsContext();
				setTimeout(() => {
					this.refreshMask();
				}, 100);
				setTimeout(() => {
					if (this.dadataAddressControl) {
						this.dadataAddressControl.initValue(this.contragent.address);
					}
				}, 1000);
        	});
		} 
		else {
            this.contragent = new ContragentWithContactDto();
            this.entityViewModel = new EntityViewModel<Contragent>();
            this.entityViewModel.entity = new Contragent();
            this.entityViewModel.entity.createdDate = new Date();
            this.canEditForm = true;
            this.isNew = true;
			this.loaded = true;
			this.canEditForm = true;
        }
	}

	saveChanges() {
		this.dataSaving = true;
		if (this.contragent.id == null || this.contragent.id == 0) {
			this.dataService.createContragentWithContact(this.contragent).subscribe((resp) => {
				this.dataSaving = false;
				window.location.replace(`/categories/contragent/${resp.data}`);        
			});
		}
		else {
			this.dataService.updateContragentWithContact(this.contragent).subscribe(() => {
				this.dataService.getContragentWithContact(this.contragent.id).subscribe(resp => {
					this.contragent = resp;
					this.canEditForm = false;
					this.dataSaving = false;
					this.loadContragentProjects();
				});
			});
		}
	}

	onAddressChange(value: AddressSuggestion) {
		this.contragent.address = value.address;
	}

	editEnable() {
		this.updatedContragent = { ...this.contragent };
		this.canEditForm = true;
	}

	editDisable() {
		this.contragent = { ...this.updatedContragent };
		this.canEditForm = false;
	}

	setMask(mask: string) {
		this.cellPhoneMask = mask;
		this.contragent.contactPhone = '';
	}

	refreshMask() {
		if (this.countryPhoneMasksComponent) {
			this.cellPhoneMask = this.countryPhoneMasksComponent.getAndSetPhoneMask(this.contragent.contactPhone);
		}
	}

	get saveContragentAvailable() {
		return this.contragent && this.contragent.contactPhone;
	}

	loadClientProjectsContext() {
		const contragentId = (this.contragent && this.contragent.id) || +this.entityId;
		if (!contragentId) {
			this.clientAgreements = [];
			this.agreementId = null;
			this.contragentProjects = [];
			this.projectsContextReady = true;
			return;
		}

		this.projectsLoading = true;
		this.agreementsService.list({
			skip: 0,
			take: 200,
			filter: {
				logic: 'and',
				filters: [{ field: 'contragentId', operator: 'eq', value: contragentId }]
			}
		}).subscribe(result => {
			const activeAgreements = ((result && result.data) || [])
				.filter(agreement => agreement.stateId === AgreementState.active)
				.sort((a, b) => a.agreementId - b.agreementId);

			this.clientAgreements = activeAgreements.map(agreement =>
				new KeyValueObject(agreement.agreementId, this.agreementTitle(agreement)));

			const selectedStillExists = this.clientAgreements.some(agreement => agreement.id === this.agreementId);
			if (!selectedStillExists) {
				this.agreementId = this.clientAgreements.length > 0 ? this.clientAgreements[0].id : null;
			}

			this.projectsContextReady = true;
			this.loadContragentProjects();
		}, () => {
			this.clientAgreements = [];
			this.agreementId = null;
			this.projectsContextReady = true;
			this.projectsLoading = false;
			this.loadContragentProjects();
		});
	}

	onAgreementContextChange(agreementId: number) {
		this.agreementId = agreementId;
		this.loadContragentProjects();
	}

	loadContragentProjects() {
		const contragentId = (this.contragent && this.contragent.id) || +this.entityId;
		if (!contragentId) {
			this.contragentProjects = [];
			this.projectsLoading = false;
			return;
		}

		const filters: any[] = [{ field: 'contragentId', operator: 'eq', value: contragentId }];
		if (this.agreementId) {
			filters.push({ field: 'agreementId', operator: 'eq', value: this.agreementId });
		}

		this.projectsLoading = true;
		this.lookupService.getData("contragent-projects", {
			skip: 0,
			take: null,
			filter: { logic: 'and', filters }
		}).subscribe(resp => {
			this.contragentProjects = resp || [];
			this.projectsLoading = false;
		}, () => {
			this.projectsLoading = false;
		});
	}

	onContragentProjectsChanged() {
		this.loadContragentProjects();
	}

	private agreementTitle(agreement: AgreementListItem): string {
		const named = agreement as AgreementListItem & { name?: string };
		if (named.number) {
			return named.number;
		}

		if (named.name) {
			return named.name;
		}

		return `Договор ${agreement.agreementId}`;
	}
}